import * as React from 'react'

const SvgEditIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.25 16.875h17.5v1.25H1.25v-1.25zm14.631-11.25a1.25 1.25 0 000-1.769L13.644 1.62a1.25 1.25 0 00-1.769 0L2.5 10.994V15h4.006l9.375-9.375zM12.756 2.5L15 4.744l-1.875 1.875-2.244-2.244L12.756 2.5zM3.75 13.75v-2.244L10 5.256 12.244 7.5l-6.25 6.25H3.75z"
      fill="#163250"
    />
  </svg>
)

export default SvgEditIcon
